import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import { Image } from "primereact/image";

import boyShock from "../../../assets/images/health/submit-for-passport-failed.png";
import { useTranslation } from 'react-i18next';

const SubmitForPassportFailed = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const submitSelectedPlan = () => {
        navigate(`/get-health-quotes`);
    };

    return (
        <div className="content d-flex flex-row px-2" style={{ height: "90vh"}}>
            <div className="get-quote-process-container align-items-center justify-content-center vw-50">
                <div className="d-flex flex-column align-items-center justify-content-center">
                    <Image 
                        className="px-3"
                        src={boyShock}
                        width="300"
                        height="auto"
                    />
                    <h3 className="text-center mb-4">{`${t(`healthInsurance.negativeSubmissionFailed.title`)}`}</h3>
                    <span className="text-center">
                        <span className="formatted-text">{`${t(`healthInsurance.negativeSubmissionFailed.subTitle`)}`}</span>
                        <span><a href={`/ansa-help`} className="color-primary fw-bold">{`${t(`common.ansaHelp`)}`}</a></span>
                        <span className="formatted-text">{`${t(`healthInsurance.negativeSubmissionFailed.forAssistance`)}`}</span>
                    </span>
                </div>
            </div>
            
            <div className="btn-footer pb-4">
                <Button
                    label={`${t(`common.tryAgain`)}`}
                    className="btn-primary"
                    loading={loading}
                    onClick={submitSelectedPlan}
                />
            </div>
        </div>
    );
};

export default SubmitForPassportFailed;
